import './App.css';
import { useState, useRef } from 'react';
import * as bodyPix from '@tensorflow-models/body-pix';
import * as tf from '@tensorflow/tfjs';

function App() {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [quality, setQuality] = useState('high');
  const [threshold, setThreshold] = useState(0.7);
  const imgRef = useRef(null);
  const canvasRef = useRef(null);

  const handleUpload = (e) => {
    setImage(URL.createObjectURL(e.target.files[0]));
  };

  const changeBackground = async () => {
    if (!imgRef.current) return;
    setLoading(true);
    try {
      await tf.setBackend('webgl');
    } catch {
      await tf.setBackend('cpu');
    }
    await tf.ready();

    const options =
      quality === 'high'
        ? {
            architecture: 'ResNet50',
            outputStride: 16,
            quantBytes: 2,
          }
        : {
            architecture: 'MobileNetV1',
            outputStride: 16,
            multiplier: 0.75,
            quantBytes: 2,
          };

    const net = await bodyPix.load(options);

    const tempCanvas = document.createElement('canvas');
    const maxWidth = 800;
    const scale = Math.min(1, maxWidth / imgRef.current.width);
    tempCanvas.width = imgRef.current.width * scale;
    tempCanvas.height = imgRef.current.height * scale;

    const ctx = tempCanvas.getContext('2d');
    ctx.drawImage(imgRef.current, 0, 0, tempCanvas.width, tempCanvas.height);

    const segmentation = await net.segmentPerson(tempCanvas, {
      internalResolution: quality === 'high' ? 'high' : 'medium',
      segmentationThreshold: threshold,
    });

    const mask = bodyPix.toMask(
      segmentation,
      { r: 0, g: 0, b: 0, a: 0 },
      { r: 255, g: 255, b: 255, a: 255 }
    );

    const canvas = canvasRef.current;
    canvas.width = imgRef.current.naturalWidth;
    canvas.height = imgRef.current.naturalHeight;
    bodyPix.drawMask(canvas, tempCanvas, mask, 1, 'white');

    setLoading(false);
  };

  return (
    <div className="app-container">
      <div className="quality-row">
        <label htmlFor="quality-select">モデル:</label>
        <select
          id="quality-select"
          value={quality}
          onChange={(e) => setQuality(e.target.value)}
        >
          <option value="high">ResNet50（精度高）</option>
          <option value="low">MobileNetV1（精度低）</option>
        </select>
      </div>

      <div className="threshold-row">
        <label htmlFor="threshold-slider">耳や髪を残す度合い:</label>
        <input
          id="threshold-slider"
          type="range"
          min="0.5"
          max="0.7"
          step="0.05"
          value={threshold}
          onChange={(e) => setThreshold(parseFloat(e.target.value))}
        />
        <span>{threshold}</span>
      </div>

      <div className="button-row">
        <div className="button-block left-block">
          <input
            type="file"
            accept="image/*"
            onChange={handleUpload}
            className="upload-file-button"
          />
        </div>
        <div className="button-block right-block">
          <div className="button-with-status">
            <button
              onClick={changeBackground}
              className="change-background-button"
            >
              背景を白に変更
            </button>
            <div
              className={`loading-status-text ${
                loading ? 'status-visible' : 'status-hidden'
              }`}
            >
              処理中...
            </div>
          </div>
        </div>
      </div>

      <div className="preview-row">
        <div className="preview-box">
          {image && (
            <img
              ref={imgRef}
              src={image}
              alt="元画像"
              className="img-original"
            />
          )}
        </div>
        <div className="preview-box">
          <canvas ref={canvasRef} className="img-result"></canvas>
        </div>
      </div>
    </div>
  );
}

export default App;
